import { cookieGet } from '@/common/cookie'
import qs from 'qs'

//这里应该是一组数据管理相关的混入,现修改为公共函数混入

/**
 * 关于loading部分的说明:
 * loading辅助库支持指令和服务两种方式
 * -  指令方式
 *    要通过指令调用loading,首先要声明v-loading,绑定的变量可以是elLoading,一个默认的槽位,对应于elLoadingObj.default
 *    如果还需要更多的变量,则要在v-loading处指定elLoadingObj[key],变动时需要在相关函数处传入tag参数
 * -  服务方式
 *    服务方式为单例执行,不支持多开,调用方式为无参调用,可见下面的声明
 */
export default {
  data() {
    return {
      loadingInstance: null,
      elLoading: false,
      elLoadingObj: { default: false },
      ISDEV: process.env.NODE_ENV === 'development',
    }
  },
  watch: {
    'elLoadingObj.default'(newVal) {
      this.elLoading = newVal;
    }
  },
  methods: {
    /**
     * 通过一个promise设置loading属性
     * @param {Promise} pending 
     * @param {keyof Object} tag 
     */
    setElLoading(pending, tag = 'default') {
      //不传promise是不会生效的
      if (pending instanceof Promise) {
        this.elLoadingObj[tag] = true;

        pending.finally(() => this.endElLoading(tag));
      }
    },
    /**
     * 立即结束指定tag的加载
     * @param {keyof Object} tag 
     */
    endElLoading(tag = 'default') {
      this.elLoadingObj[tag] = false;
    },
    /**
     * 使用默认配置调用加载弹框,如果连续showLoading,后续的调用静默失败
     */
    showLoading() {
      if (this.loadingInstance === null) {
        this.loadingInstance = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      }
    },
    /**
     * 关闭加载弹框,如果未调用过showLoading,静默失败
     */
    endLoading() {
      if (this.loadingInstance !== null) {
        this.loadingInstance.close();
        this.loadingInstance = null;
      }
    }
  }
}

// export default {
//   data () {
//     /* eslint-disable */
//     return {
//       // 设置属性
//       mixinViewModuleOptions: {
//         activatedIsNeed: true,    // 此页面是否在激活（进入）时，调用查询数据列表接口？
//         getDataListURL: '',       // 数据列表接口，API地址
//         getDataListIsPage: false, // 数据列表接口，是否需要分页？
//         deleteURL: '',            // 删除接口，API地址
//         deleteIsBatch: false,     // 删除接口，是否需要批量？
//         deleteIsBatchKey: 'id',   // 删除接口，批量状态下由那个key进行标记操作？比如：pid，uid...
//         exportURL: ''             // 导出接口，API地址
//       },
//       // 默认属性
//       dataForm: {},               // 查询条件
//       dataList: [],               // 数据列表
//       dataObject: null,           // 数据对象
//       order: '',                  // 排序，asc／desc
//       orderField: '',             // 排序，字段
//       pageSizes:[10, 20,30,50,100,200,300,500,1000], //分页
//       page: 1,                    // 当前页码
//       limit: 20,                  // 每页数
//       total: 0,                   // 总条数
//       dataListLoading: false,     // 数据列表，loading状态
//       dataListSelections: [],     // 数据列表，多选项
//       addOrUpdateVisible: false,   // 新增／更新，弹窗visible状态
//       statusCount:{}
//     }
//     /* eslint-enable */
//   },
//   activated () {
//     if (this.mixinViewModuleOptions.activatedIsNeed) {
//       this.getDataList()
//     }
//   },
//   created () {
//     if (this.mixinViewModuleOptions.activatedIsNeed) {
//       this.getDataList()
//     }
//   },
//   methods: {
//     // 获取数据列表
//     getDataList (callback) {
//       this.dataListLoading = true
//       this.$axios.get(
//         this.mixinViewModuleOptions.getDataListURL,
//         {
//           params: {
//             // order: this.order,
//             // orderField: this.orderField,
//             //接口参数不同做兼容
//             beginpage: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
//             beginPage: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
//             beginrow: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
//             beginRow: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
//             rowsize: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
//             rowSize: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
//             ...this.dataForm
//           }
//         }
//       ).then(res => {
//         this.dataListLoading = false
//         this.dataList = res.list
//         this.dataObject = res.data || null
//         // this.dataList = this.mixinViewModuleOptions.getDataListIsPage ? res.list : res
//         this.total = this.mixinViewModuleOptions.getDataListIsPage ? res.count : 0
//         if(res.statusCount){
//         	this.statusCount=res.statusCount
//         }
//         if (callback) {
//           callback(res)
//         }
//       }).catch(() => {
//         this.dataList = []
//         this.total = 0
//         this.dataListLoading = false
//       })
//     },
//     // 多选
//     dataListSelectionChangeHandle (val) {
//       this.dataListSelections = val
//     },
//     // 排序
//     dataListSortChangeHandle (data) {
//       if (!data.order || !data.prop) {
//         this.order = ''
//         this.orderField = ''
//         return false
//       }
//       this.order = data.order.replace(/ending$/, '')
//       this.orderField = data.prop.replace(/([A-Z])/g, '_$1').toLowerCase()
//       this.getDataList()
//     },
//     // 分页, 每页条数
//     pageSizeChangeHandle (val) {
//       this.page = 1
//       this.limit = val
//       this.getDataList()
//     },
//     // 分页, 当前页
//     pageCurrentChangeHandle (val) {
//       this.page = val
//       this.getDataList()
//     },
//     // 新增 / 修改
//     addOrUpdateHandle (id) {
//       this.addOrUpdateVisible = true
//       this.$nextTick(() => {
//         this.$refs.addOrUpdate.dataForm.id = id
//         this.$refs.addOrUpdate.init()
//       })
//     },
//     // 删除
//     deleteHandle (id) {
//       if (this.mixinViewModuleOptions.deleteIsBatch && !id && this.dataListSelections.length <= 0) {
//         return this.$message({
//           message: this.$t('prompt.deleteBatch'),
//           type: 'warning',
//           duration: 500
//         })
//       }
//       this.$confirm(this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
//         confirmButtonText: this.$t('confirm'),
//         cancelButtonText: this.$t('cancel'),
//         type: 'warning'
//       }).then(() => {
//         this.$axios.delete(
//           `${this.mixinViewModuleOptions.deleteURL}${this.mixinViewModuleOptions.deleteIsBatch ? '' : '/' + id}`,
//           this.mixinViewModuleOptions.deleteIsBatch ? {
//             'data': id ? [id] : this.dataListSelections.map(item => item[this.mixinViewModuleOptions.deleteIsBatchKey])
//           } : {}
//         ).then(res => {
//           this.getDataList()
//         }).catch(() => {})
//       }).catch(() => {})
//     },
//     // 导出
//     exportHandle () {
//       var params = qs.stringify({
//         'token': cookieGet('token'),
//         'orderstatus':this.dataForm.orderStatus,
//         ...this.dataForm
//       })
//       window.location.href = `${window.SITE_CONFIG['apiURL']}${this.mixinViewModuleOptions.exportURL}?${params}`
//     }
//   }
// }
